import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "edit",
  "use": "edit-usage",
  "viewBox": "0 0 8 8",
  "content": "<symbol viewBox=\"0 0 8 8\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"edit\">\n<path d=\"M0 6.3331V8H1.6669L6.58536 3.08154L4.91846 1.41464L0 6.3331ZM7.86998 1.79692C8.04334 1.62356 8.04334 1.3413 7.86998 1.16794L6.83206 0.130018C6.6587 -0.0433394 6.37644 -0.0433394 6.20308 0.130018L5.38964 0.943464L7.05654 2.61036L7.86998 1.79692Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol